import { shallowMount } from "@vue/test-utils";
import CheckItem from "@/components/core/custom/CheckItem";

describe("CheckItem component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CheckItem);
  });

  it("Renders del component CheckItem", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
